export default "__VITE_ASSET__Cn4qmPLA__"